import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { NavLink } from "react-router-dom";
import config from "../configs/config";
import AgencyCreate from "../features/agency-register/ui/AgencyCreateForm";
import { getCurrentLanguageKey, getLanguageSection } from "../shared/services/languageService";

function AgencyRegister() {
  useEffect(() => {
    const verifylogin = setInterval(() => {
      if (Cookies.get("loggedin") === "true") {
        clearInterval(verifylogin);
        window.location.href = config.basename;
      }
    }, 1000);

    return () => clearInterval(verifylogin);
  }, []);

  const currentLanguage = getCurrentLanguageKey();
  const language = getLanguageSection("agencyregister");

  return (
    <div id="agencyregister" className="mr-ui bg-[#f3f5fb] px-4 py-10 md:px-8">
      <div className="mx-auto w-full max-w-5xl">
        <div className="mx-auto mb-6 rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-marival">
          <h1 className="m-0 text-3xl font-black leading-tight text-[#11183f] md:text-4xl">{language.text1}</h1>
          <p className="mx-auto mb-0 mt-4 max-w-2xl text-base leading-7 text-slate-600">
            {language.text2}
          </p>
          <div className="mt-4 text-sm leading-6 text-slate-500">
            <NavLink
              to={`/agentregister?lang=${currentLanguage}`}
              className="font-black text-[#f5660b] hover:text-[#c94c04]"
            >
              {language.text3}
            </NavLink>
          </div>
        </div>

        <AgencyCreate
          withButton={false}
          showInlineTitle={false}
          title={language.text1}
        />
      </div>
    </div>
  );
}

export default AgencyRegister;
